var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProductivity = function SvgProductivity(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19ZM15.2607 8.71777C14.8285 8.57369 14.3619 8.807 14.2178 9.23926C14.0737 9.67151 14.307 10.1381 14.7393 10.2822L16.1992 10.7686L12.2988 12.8955L11.207 11.0752C10.9872 10.7093 10.5287 10.5754 10.1504 10.7529L10.0752 10.793L5.0752 13.793C4.68483 14.0275 4.55863 14.5342 4.79297 14.9248C5.0275 15.3152 5.53424 15.4414 5.9248 15.207L10.2168 12.6309L11.293 14.4248C11.5207 14.8039 12.0072 14.9364 12.3955 14.7246L16.8662 12.2852L16.6865 13.3643C16.6116 13.8136 16.9149 14.2385 17.3643 14.3135C17.8136 14.3884 18.2385 14.0851 18.3135 13.6357L18.8135 10.6357C18.8802 10.2353 18.6459 9.84615 18.2607 9.71777L15.2607 8.71777Z",
    fill: "#0D0D0D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProductivity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Productivity.29bf9d5c55632f2b05d414894502b407.svg";